module.exports = __webpack_public_path__ + "static/img/215.4de8610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/191007/215.jpg
// module id = d63c
// module chunks = 0